export const MovementActionType = {
  ARRIVAL: 'ARRIVAL',
  DEPARTURE: 'DEPARTURE',
  SHIFT_ARRIVAL: 'SHIFT_ARRIVAL',
  SHIFT_DEPARTURE: 'SHIFT_DEPARTURE'
};